// AnalyticsTopBar — Renders the top-bar navigation on non-AI pages, for
// workspaces whose flag turns it on. It takes the same actions as
// AnalyticsSidebar, so both shells reach every destination the same way.

import '../features/dashai/index.css';
import { TopBar } from '@dashai/components/dashai/TopBar/TopBar';
import { useRecentChats } from '@dashai/hooks/useRecentChats';

import { useAnalyticsNavActions } from '../hooks/useAnalyticsNavActions';
import { useWorkspaceListStatus } from '../hooks/useWorkspaceListStatus';

export default function AnalyticsTopBar() {
  const navActions = useAnalyticsNavActions();
  const workspaceListStatus = useWorkspaceListStatus();
  const { recentChats, loading: recentChatsLoading, load } = useRecentChats(navActions.currentClient);
  return (
    <div className="dashai-scope">
      <TopBar
        {...navActions}
        workspaceListLoaded={workspaceListStatus.loaded}
        workspaceListError={workspaceListStatus.error}
        onRetryWorkspaceList={workspaceListStatus.retry}
        recentChats={recentChats}
        recentChatsLoading={recentChatsLoading}
        onOpenDashAIPanel={load}
      />
    </div>
  );
}
